import request from '@/utils/axios';

// 用户接口
export const info           = ()        => request.get('/auth/user');
export const setInfo        = p         => request.put('/auth/user', p);
export const setPassword    = p         => request.put('/auth/user/password', p);
export const bindMobile     = p         => request.put('/auth/user/mobile', p);

// 开放用户接口
export const getBaseInfo    = p         => request.get(`/auth/open/user/${p}`);
export const openReg        = p         => request.post('/auth/open/reg', p);

// 校区操作用户接口
export const userList       = params    => request.get('/auth/users', {params});
export const userImport     = params    => request.get('/auth/user/import', {params});
export const userExport     = params    => request.get('/auth/user/export', {params});
export const createUser     = p         => request.post('/auth/users', p);
export const updateUser     = p         => request.put(`/auth/users/${p.id}`, p);
export const resetPwd       = p         => request.put(`/auth/users/reset/${p.id}`);
